import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Slide, Zoom } from "react-awesome-reveal";
import { MagnifyingGlass } from "react-loader-spinner";
import ScrollToTop from "../ScrollToTop";
import logo from "../../images/almoune-logo-1613775290.jpg";
import graphics from "../../images/store-graphics.svg";
import livraisonImage from "../../images/almoune/livraison-gratuite.jpg";
import junetImage from "../../images/almoune/junet.jpg";
import hallabImage from "../../images/almoune/hallab-baklava.jpg";

const services = [
  {
    title: "Epicerie libanaise",
    subtitle: "Le coeur de la boutique",
    details: ["Condiments et conserves", "Pains et aides culinaires", "Produits du quotidien"],
    badge: "Selection Almoune",
  },
  {
    title: "Boissons et cafe",
    subtitle: "Pour les amateurs de saveurs orientales",
    details: ["Cafe Najjar", "Jus et boissons Junet", "Selections saisonnieres"],
    badge: "Populaire",
  },
  {
    title: "Douceurs et cadeaux",
    subtitle: "Baklava, biscuits et gourmandises",
    details: ["Hallab 1881", "Gandour et Unica", "Produits a offrir"],
    badge: "Coup de coeur",
  },
];

const highlights = [
  {
    image: livraisonImage,
    title: "Livraison a domicile",
    text: "Livraison standard offerte a partir de 49 EUR sur les commandes eligibles.",
  },
  {
    image: junetImage,
    title: "Marques aimees",
    text: "Des produits connus et recherches par les clients de l'epicerie orientale.",
  },
  {
    image: hallabImage,
    title: "Selections premium",
    text: "Une mise en avant de gourmandises, coffrets et produits signatures.",
  },
];

const StoreList = () => {
  const [loaderStatus, setLoaderStatus] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoaderStatus(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div>
      {loaderStatus ? (
        <div className="loader-container">
          <MagnifyingGlass
            visible={true}
            height="100"
            width="100"
            ariaLabel="magnifying-glass-loading"
            wrapperStyle={{}}
            wrapperclassName="magnifying-glass-wrapper"
            glassColor="#c0efff"
            color="#0aad0a"
          />
        </div>
      ) : (
        <>
          <ScrollToTop />

          <div className="mt-4">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <nav aria-label="breadcrumb">
                    <ol className="breadcrumb mb-0">
                      <li className="breadcrumb-item">
                        <Link to="/Grocery-react/">Accueil</Link>
                      </li>
                      <li className="breadcrumb-item active" aria-current="page">
                        Services Almoune
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
          </div>

          <section className="mt-8">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="bg-light rounded-3 d-flex justify-content-between align-items-center flex-wrap">
                    <div className="d-flex align-items-center p-10">
                      <Slide direction="down">
                        <div>
                          <h1 className="mb-2 fw-bold">Services Almoune</h1>
                          <p className="mb-0 text-muted">
                            Une page simple pour presenter les univers de la boutique et la facon de commander.
                          </p>
                        </div>
                      </Slide>
                    </div>
                    <div className="p-6 text-center">
                      <Zoom>
                        <img src={graphics} alt="Almoune services" className="img-fluid" style={{ maxWidth: "220px" }} />
                      </Zoom>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="mt-6 mb-lg-14 mb-8">
            <div className="container">
              <div className="row align-items-center mb-6">
                <div className="col-lg-7">
                  <div className="d-flex align-items-center gap-4 flex-wrap">
                    <img src={logo} alt="Almoune" className="img-fluid rounded-3" style={{ width: "220px" }} />
                    <div>
                      <h3 className="mb-2">Une seule boutique, plusieurs univers</h3>
                      <p className="mb-0 text-muted">
                        Almoune rassemble les produits libanais et orientaux les plus recherches, avec une presentation simple et un parcours d'achat plus clair.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5 text-lg-end mt-4 mt-lg-0">
                  <h6 className="mb-0">
                    <span className="text-primary">3</span> univers principaux mis en avant
                  </h6>
                </div>
              </div>

              <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                {services.map((service) => (
                  <Zoom key={service.title}>
                    <div className="col">
                      <div className="card h-100 p-4 card-product">
                        <div className="card-body p-2">
                          <span className="badge text-bg-light border mb-3">{service.badge}</span>
                          <h4 className="mb-1">{service.title}</h4>
                          <p className="text-muted small mb-3">{service.subtitle}</p>
                          <ul className="list-unstyled small mb-4">
                            {service.details.map((detail) => (
                              <li className="mb-2" key={detail}>
                                <i className="fa fa-check text-success me-2" />
                                {detail}
                              </li>
                            ))}
                          </ul>
                          <Link to="/Shop" className="btn btn-primary btn-sm">
                            Voir la boutique
                          </Link>
                        </div>
                      </div>
                    </div>
                  </Zoom>
                ))}
              </div>
            </div>
          </section>

          <section className="mb-lg-14 mb-8">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <div className="mb-6">
                    <h3 className="mb-0">Points forts Almoune</h3>
                  </div>
                </div>
              </div>
              <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                {highlights.map((item) => (
                  <Zoom key={item.title}>
                    <div className="col">
                      <div className="card h-100 border-0 shadow-sm">
                        <img
                          src={item.image}
                          alt={item.title}
                          className="card-img-top"
                          style={{ height: "220px", objectFit: "cover" }}
                        />
                        <div className="card-body p-4">
                          <h4 className="mb-2">{item.title}</h4>
                          <p className="text-muted mb-0">{item.text}</p>
                        </div>
                      </div>
                    </div>
                  </Zoom>
                ))}
              </div>
            </div>
          </section>

          <section className="mb-lg-14 mb-8">
            <div className="container">
              <div className="card border-0 shadow-sm">
                <div className="card-body p-5 text-center">
                  <h3 className="mb-2">Commander chez Almoune</h3>
                  <p className="text-muted mb-4">
                    Retrouvez les categories, les produits favoris, le panier et le paiement directement depuis la boutique en ligne.
                  </p>
                  <div className="d-flex justify-content-center gap-3 flex-wrap">
                    <Link to="/Shop" className="btn btn-primary">
                      Aller a la boutique
                    </Link>
                    <Link to="/ShopCart" className="btn btn-outline-dark">
                      Voir le panier
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </div>
  );
};

export default StoreList;
